import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AppLayout } from "./components/layout/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ClfsPage from "./pages/ClfsPage";
import VosPage from "./pages/VosPage";
import ShgsPage from "./pages/ShgsPage";
import MembersPage from "./pages/MembersPage";
import LoansPage from "./pages/LoansPage";
import RepaymentsPage from "./pages/RepaymentsPage";
import ReportsPage from "./pages/ReportsPage";
import WhatsAppPage from "./pages/WhatsAppPage";
import SettingsPage from "./pages/SettingsPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="clfs" element={<ClfsPage />} />
            <Route path="vos" element={<VosPage />} />
            <Route path="shgs" element={<ShgsPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="loans" element={<LoansPage />} />
            <Route path="repayments" element={<RepaymentsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="whatsapp" element={<WhatsAppPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
